import React from 'react';
import { Navigate } from 'react-router-dom';
import PdfAndExcel from './PdfAndExcel';

const PrivateRoute = () => {
  const token = localStorage.getItem('authToken');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <PdfAndExcel />;
};
  
  export default PrivateRoute;
